/**
 * 将页面的 dimension（驼峰命名）转换为下载弹窗的 genre_dimension value（下划线命名）
 */
const mapDimensionToGenreValue = (dimension: string): string => {
  const dimensionMap: Record<string, string> = {
    mainGenre: 'main_genre',
    subGenre: 'sub_genre',
    superGenre: 'super_genre',
    majorCategory: 'major_category',
    midCategory: 'mid_category',
    subCategory: 'sub_category',
  };
  return dimensionMap[dimension] || '';
};

/**
 * 根据品类数据源获取Genre选项配置
 * @param genreSource 品类数据源 ('sensortower' | 'appmagic')
 */
const getGenreOptions = (genreSource: string) => {
  if (genreSource === 'sensortower') {
    // Sensor Tower 数据源：Main Genre、Sub Genre
    return [
      { label: 'dbi_main_genre', value: 'main_genre' },
      { label: 'dbi_sub_genre', value: 'sub_genre' },
    ];
  }
  // App Magic 数据源：Super Genre、Level-1/2/3 Genre
  return [
    { label: 'dbi_casual_dimension_super_genre', value: 'super_genre' },
    { label: 'dbi_casual_dimension_level1_genre', value: 'major_category' },
    { label: 'dbi_casual_dimension_level2_genre', value: 'mid_category' },
    { label: 'dbi_casual_dimension_level3_genre', value: 'sub_category' },
  ];
};

/**
 * 根据品类数据源和当前页面维度获取默认Genre选项
 * @param genreSource 品类数据源 ('sensortower' | 'appmagic')
 * @param dimension 当前页面选中的品类维度
 */
const getGenreDefaultValue = (genreSource: string, dimension?: string) => {
  // 优先使用页面当前选中的维度
  if (dimension) {
    const mappedValue = mapDimensionToGenreValue(dimension);
    // 检查映射后的值是否在选项中
    const options = getGenreOptions(genreSource);
    if (options.some((opt) => opt.value === mappedValue)) {
      return mappedValue;
    }
  }
  // fallback 到原有逻辑
  if (genreSource === 'sensortower') {
    return 'sub_genre'; // Sensor Tower 默认勾选 Sub Genre
  }
  return 'major_category'; // App Magic 默认勾选 Level-1 Genre
};

export default {
  casualGenreProfile: {
    apiUrl: '',
    bubbleText: '',
    translate: true,
    // 动态formList函数，根据tableParams.genreSource返回不同的配置
    getFormList: (tableParams: any = {}) => {
      const { genreSource = 'appmagic', dimension } = tableParams; // 获取页面当前维度
      return [
        {
          label: 'dbi_label_genre',
          type: 'radio',
          defaultValue: getGenreDefaultValue(genreSource, dimension),
          field: 'genre_dimension',
          options: getGenreOptions(genreSource),
        },
        {
          label: 'dbi_label_data_calculation',
          type: 'subForm',
          children: [
            {
              label: 'dbi_label_time_settings',
              type: 'radio',
              defaultValue: 'aggregated',
              field: 'date_method',
              options: [
                { label: 'dbi_label_aggregated', value: 'aggregated' },
                { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
              ],
            },
            {
              label: 'dbi_label_region_settings',
              type: 'radio',
              field: 'region_method',
              defaultValue: 'aggregated',
              options: [
                { label: 'dbi_label_aggregated', value: 'aggregated' },
                { label: 'dbi_label_separate_by_country_combine', value: 'market' },
                { label: 'dbi_label_separate_by_region_combine', value: 'region' },
              ],
            },
            {
              label: 'dbi_label_ratio',
              type: 'switch',
              defaultValue: true,
              field: 'ratio_show',
              options: [],
            },
          ],
        },
      ];
    },
    // 保留原有的静态formList作为fallback
    formList: [
      {
        label: 'dbi_label_genre',
        type: 'radio',
        defaultValue: 'major_category',
        field: 'genre_dimension',
        options: [
          { label: 'dbi_casual_dimension_super_genre', value: 'super_genre' },
          { label: 'dbi_casual_dimension_level1_genre', value: 'major_category' },
          { label: 'dbi_casual_dimension_level2_genre', value: 'mid_category' },
          { label: 'dbi_casual_dimension_level3_genre', value: 'sub_category' },
        ],
      },
      {
        label: 'dbi_label_data_calculation',
        type: 'subForm',
        children: [
          {
            label: 'dbi_label_time_settings',
            type: 'radio',
            defaultValue: 'aggregated',
            field: 'date_method',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_time_combine', value: 'separate' },
            ],
          },
          {
            label: 'dbi_label_region_settings',
            type: 'radio',
            field: 'region_method',
            defaultValue: 'aggregated',
            options: [
              { label: 'dbi_label_aggregated', value: 'aggregated' },
              { label: 'dbi_label_separate_by_country_combine', value: 'market' },
              { label: 'dbi_label_separate_by_region_combine', value: 'region' },
            ],
          },
          {
            label: 'dbi_label_ratio',
            type: 'switch',
            defaultValue: true,
            field: 'ratio_show',
            options: [],
          },
        ],
      },
    ],
  },
};
